// extracted by mini-css-extract-plugin
export default {"sider":"styles_sider__DQKWD","content":"styles_content__YvQ5N","loadingContainer":"styles_loadingContainer__sECUg"};